import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { ListItemIcon } from "@material-ui/core";

const ITEM_HEIGHT = 48;

export interface MenuItemProperties {
  label: string;
  icon?: string;
  key?: string | number;
  onClick(): void;
}

export interface ActionMenuProperties {
  selected?: string | null;
  menuItens: MenuItemProperties[];
}

const ActionMenu = (props: ActionMenuProperties) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectdIndex, setSelectedIndex] = React.useState<number | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={props.menuItens.length <= 0}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            //width: "20ch",
          },
        }}
      >
        {props.menuItens.map((item: MenuItemProperties, idx: number) => (
          <MenuItem
            key={`menu-item-${idx}-${item.key}`}
            selected={selectdIndex === idx}
            onClick={() => {
              item.onClick();
              handleClose();
            }}
          >
            {item?.icon ? (
              <ListItemIcon>
                <Icon fontSize="small">{item.icon}</Icon>
              </ListItemIcon>
            ) : (
              ""
            )}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export { ActionMenu };
